import EditorNav from './index.vue';
import Beautify from './components/beautify';
import DesignTemplate from './components/design-template';
import Matting from './components/matting';
import Tools from './components/tools';
import User from './components/user';
import NavItem from './components/nav-item';
import ToolsPopover from './components/tools-popover';
import OtherNav from './other-nav';
import V2OtherNav from './v2-other-nav';
EditorNav.Beautify = Beautify;
EditorNav.DesignTemplate = DesignTemplate;
EditorNav.Matting = Matting;
EditorNav.Tools = Tools;
EditorNav.User = User;
EditorNav.NavItem = NavItem;
EditorNav.OtherNav = OtherNav;
EditorNav.ToolsPopover = ToolsPopover;
EditorNav.V2OtherNav = V2OtherNav;
export default EditorNav;